import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Icon } from "@iconify/react";
import { useState } from "react";

interface CopyButtonProps {
  value: string;
  className?: string;
}

export function CopyButton({ value, className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={copy}
      className={cn("h-8 w-8", className)}
      title={copied ? "Copied!" : "Copy to clipboard"}
    >
      <Icon
        icon={copied ? "lucide:check" : "lucide:copy"}
        className="h-4 w-4"
      />
    </Button>
  );
}
